module.exports = __webpack_public_path__ + "static/media/earlexFlyer2Front.63477c8b.jpg";